import { render, staticRenderFns } from "./EmailVerificationLogs.vue?vue&type=template&id=0f2df4ee&"
import script from "./EmailVerificationLogs.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports